import * as React from 'react'

import * as _ from 'lodash'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import { bindActionCreators, compose } from 'redux'

import * as UserActions from '../../store/user/actions'

import { databaseRef } from 'config/firebase'

import SnackbarService from '../../services/snackbars'
import Content from './content'

import { withPlusUserListenerConsumer } from 'components'
import { clearPlusUser } from 'services/plusUsers'
import * as PlusUserActions from 'store/plusUsers/actions'
import { _route } from '../../routes/config'

import './style.scss'

interface INativeProps {}
interface IReduxStateProps {
  user: any
  uid: string
}
interface IReduxDispatchProps {
  UserLib: any
  PlusUserLib: any
}
interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

interface IProps
  extends INativeProps,
    IReduxProps,
    RouteComponentProps<{ email: string }> {}

interface IState {
  termsOfUse: string
}

class Confirmation extends React.Component<IProps, IState> {
  state = {
    termsOfUse: ''
  }

  async componentDidMount() {
    const {
      match: {
        params: { email }
      },
      UserLib,
      history,
      PlusUserLib
    } = this.props
    try {
      const urlParams = new URLSearchParams(
        decodeURIComponent(window.location.search)
      )
      const termsOfUse = urlParams.get('termsOfUse')
      const hash = urlParams.get('hash') || ''
      if (email && termsOfUse) {
        if (termsOfUse === 'decline') {
          UserLib.logout(() => {
            clearPlusUser(PlusUserLib)
            // const landing = process.env.REACT_APP_LANDING_URL
            // if (landing) {
            //   window.location.href = landing
            // }
          })
        }
        this.signIn(email, hash, this.processAccept)
      } else {
        SnackbarService.showSnackbar(
          'Bad redirect link used. Please try resend another one',
          'error'
        )
        history.replace('/')
      }
    } catch (error) {
      const err: string =
        typeof error === 'string'
          ? error
          : typeof error === 'object'
          ? JSON.stringify(error)
          : error.toString()
      SnackbarService.showSnackbar(
        `Error while updating terms: ${err}`,
        'error'
      )
      console.log(error)
      history.replace('/')
    }
  }

  processAccept = () => {
    const { user, history } = this.props
    const urlParams = new URLSearchParams(
      decodeURIComponent(window.location.search)
    )
    const termsOfUse = urlParams.get('termsOfUse')
    if (!user) {
      SnackbarService.showSnackbar(
        "The user isn't exist or already declined our terms",
        'info'
      )
      history.replace('/')
    } else if (user && !user.terms_not_accepted) {
      SnackbarService.showSnackbar(
        'This user already accepted our terms',
        'info'
      )
      history.replace('/')
    } else {
      this.updateTerms(termsOfUse || 'accept')
    }
  }

  updateTerms = async (termsOfUse: string, onComplete?: () => void) => {
    const { UserLib, history, user, uid } = this.props

    if (termsOfUse === 'accept') {
      const updates = {
        terms_not_accepted: null
        // paid: false
      }
      await databaseRef.child(`users/${uid}`).update(updates)
      UserLib.updateUser({ ...user, ...updates }, () =>
        history.replace(_route.welcome)
      )
    } else if (termsOfUse === 'decline') {
      // UserLib.deleteUser(
      //   uid,
      //   () => {
      //     history.replace('/add_done', { isDecline: true })
      //   },
      //   error => {
      //     console.log({ error })
      //     history.replace('/')
      //   }
      // )
      // console.log('add cryshlitics')
    }
    onComplete?.()
  }

  signIn = (
    email: string,
    hash: string,
    onSuccess: () => void = () => {
      return
    },
    onError: () => void = () => {
      return
    }
  ) => {
    const { UserLib, history, PlusUserLib } = this.props
    UserLib.login(email, atob(hash), PlusUserLib, onSuccess, error => {
      SnackbarService.showSnackbar('Error while loading data', 'error')
      onError()
      console.log('add cryshlitics')
      console.log({ error })
      history.replace('/')
    })
  }

  render() {
    return <Content termsOfUse={this.state.termsOfUse} />
  }
}

const mapStateToProps = state => ({
  user: state.user.data,
  uid: _.get(state, ['user', 'auth', 'uid'], '')
})

const mapDispatchToProps = dispatch => {
  return {
    UserLib: bindActionCreators<any, any>(UserActions, dispatch),
    PlusUserLib: bindActionCreators(PlusUserActions, dispatch)
  }
}

export default compose(
  withPlusUserListenerConsumer,
  connect(mapStateToProps, mapDispatchToProps)
)(Confirmation)



// WEBPACK FOOTER //
// ./src/pages/Confirmation/index.tsx